
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.362 5.066c.105.045.2.11.28.19l4.1 4.115.164.25a.795.795 0 01.094.378.891.891 0 01-.094.391l-.165.237-4.1 4.114a.855.855 0 01-1.225 0 .87.87 0 010-1.232l2.615-2.632h-6.16A.873.873 0 015 10a.873.873 0 01.872-.877h6.16L9.417 6.49a.87.87 0 010-1.233.856.856 0 01.945-.19z"}})])
          )
        }
      }
    